export default __webpack_public_path__ + "static/media/1.0.0.c4d106a9.yaml";